import React, { useState } from "react";
import { Tabs, Tab, Box, Typography, Card, CardContent } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useTheme } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views-react-18-fix";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            height: "100%",
            paddingX:2,
            paddingTop:2,

          }}
        >
          <Box sx={{ width: "100%" }}>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TabsView = () => {
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <Box marginX={2} height={"35%"}>
      <Card sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflowY: "auto" }}>
          <SwipeableViews index={value} onChangeIndex={handleChangeIndex}>
            <TabPanel value={value} index={0}>
              <Typography
                width={"100%"}
                fontSize={"h6.fontSize"}
                fontWeight={"bold"}
                textAlign={"center"}
              >
                消費說明01｜預約
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                1. 會員同意預約即應收取桌位使用費用。由電子收費系統第三方支付。
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                2. 會員同意預約遲到照常收費，不得延長時間。另需延長時間費用另計，若未按時預定，即視為同意屆時即停止使用該坐位。
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                3. 會員同意取消預訂應於 <strong>預定時間開始前2個小時前取消</strong>
                ，未按本規則取消不得要求退費。若有得退費之情事會員同意以
                <strong>抵用卷</strong>方式支付，並同意不以現金退費。
              </Typography>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Typography
                width={"100%"}
                fontSize={"h6.fontSize"}
                fontWeight={"bold"}
                textAlign={"center"}
              >
                消費說明02｜排隊規則
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                1. 客滿時，願意等候及無預約再依現場預約坐位，依預約方式取得時段為準。
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                2. 同意以有預約為有優先權利。
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                3. 若現場有人排隊時，不得佔用現場空位，確認坐位為預約坐位，並為坐位使用時段才可使用該坐位。
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                4. 現場不得占用非約定之坐位影響他人使用、安靜等待。
              </Typography>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Typography
                width={"100%"}
                fontSize={"h6.fontSize"}
                fontWeight={"bold"}
                textAlign={"center"}
              >
                消費說明03｜禁止事項
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                會員承諾絕不為任何非法目的或以任何非法方式使用本服務，同意本公司服務場地禁止下列情事之規範：
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                <strong>
                  1. 禁止賭博或其他賭博性交易。
                  <br />
                  2. 禁止現金交易及非法行為。
                  <br />
                  3. 未成年請勿在上課時間及晚上10點後逗留。
                  <br />
                  4. 禁止破壞場地。
                  <br />
                  5. 禁止吸菸、禁止使用毒品。
                  <br />
                  6. 除現垃圾外，禁止棄置私人垃圾。
                  <br />
                  7. 禁止在桌面上灑痱子粉、滑石粉、含相同作用之粉末。
                  <br />
                  8. 禁止飲用含酒精飲料。
                  <br />
                  9. 我們有權停止您的體驗，且不退費。恕請配合!
                  <br />
                </strong>
              </Typography>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <Typography
                width={"100%"}
                fontSize={"h6.fontSize"}
                fontWeight={"bold"}
                textAlign={"center"}
              >
                消費說明04｜備註
              </Typography>
              <Typography fontSize={"16px"} color={theme.palette.text.secondary}>
                {`請注意以上的收費和租借規則，如果有任何疑
問或需要進一步的協助，請隨時聯聚我們。`}
                <br />
                {`本體系各家自助桌遊館，對所有規則擁有最終解釋
權，如遇不遵守場館規則的行為影響到他人，`}
              </Typography>
              <Typography
                fontSize={"16px"}
                color={"error"}
                fontWeight={"bold"}

              >
                {`我們有權停止您的體驗。恕請配合!`}
              </Typography>
            </TabPanel>
          </SwipeableViews>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'end', borderTop: `1px solid ${theme.palette.divider}` }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            TabIndicatorProps={{ sx: { display: "none" } }}
            sx={{
              "& .MuiTabs-flexContainer": {
                gap: 0, // Remove the gap between tabs
              },
              "& .MuiTab-root": {
                minWidth: 0,
                padding: "0px", // Adjust padding to make tabs closer
              },
            }}
          >
            <Tab
              icon={<FiberManualRecordIcon fontSize="small" />}
              {...a11yProps(0)}
              sx={{
                "& .MuiSvgIcon-root": {
                  color: value === 0 ? theme.palette.text.blue : "#d2d2d4",
                },
              }}
            />
            <Tab
              icon={<FiberManualRecordIcon fontSize="small" />}
              {...a11yProps(1)}
              sx={{
                "& .MuiSvgIcon-root": {
                  color: value === 1 ? theme.palette.text.blue : "#d2d2d4",
                },
              }}
            />
            <Tab
              icon={<FiberManualRecordIcon fontSize="small" />}
              {...a11yProps(2)}
              sx={{
                "& .MuiSvgIcon-root": {
                  color: value === 2 ? theme.palette.text.blue : "#d2d2d4",
                },
              }}
            />
            <Tab
              icon={<FiberManualRecordIcon fontSize="small" />}
              {...a11yProps(3)}
              sx={{
                "& .MuiSvgIcon-root": {
                  color: value === 3 ? theme.palette.text.blue : "#d2d2d4",
                },
              }}
            />
          </Tabs>
        </Box>
      </Card>
    </Box>
  );
};

export default TabsView;
